import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { menuInterface } from 'src/app/Model/Seguridad/menu.Interface';

@Injectable({
  providedIn: 'root'
})
export class NewSidemeduFacadeService {

  public menus: any[] = [
    {
      idMenu: 12,
      descripcion: "Información General",
      texto: "Información General",
      idPadre: 0,
      icono: "fas fa-shopping-cart",
      url: "",
      visible: true,
      activo: true,
      subItems: true,
      idModulo: 1003,
      hijos: [
        { 
          idMenu: 20,
          idPadre: 12,
          texto: "Mi Perfil",
          descripcion: "Mi Perfil",
          icono: "fas fa-home",
          url: "afiliados/mi-perfil",
          visible: true,
          activo: true,
          subItems: true,
        },
        {
          idMenu: 17,
          idPadre: 12,
          texto: "Laboratorios",
          descripcion: "Laboratorios",
          icono: "fas fa-id-card-alt",
          url: "afiliados/laboratorios",
          visible: true,
          activo: true,
          subItems: true,
        },
   

   
       


      ],
    }
    
    // {
    //   idMenu: 50,
    //   descripcion: "Medios de Pago",
    //   texto: "Medios de Pago",
    //   idPadre: 0,
    //   icono: "fas fa-shopping-cart",
    //   url: "",
    //   visible: true,
    //   activo: true,
    //   subItems: true,
    //   idModulo: 1003,
    //   hijos: [
    //     {
    //       idMenu: 51,
    //       idPadre: 50,
    //       texto: "Deposito o Transf.",
    //       descripcion: "Deposito o Transf.",
    //       icono: "fas fa-project-diagram",
    //       url: "afiliados/registrar-pago",
    //       visible: true,
    //       activo: true,
    //       subItems: true,
    //     },
    //     {
    //       idMenu: 52,
    //       idPadre: 50,
    //       texto: "Débito Automático",
    //       descripcion: "Listado Pagos",
    //       icono: "fas fa-credit-card",
    //       url: "afiliados/mediosPago",
    //       visible: true,
    //       activo: true,
    //       subItems: true,
    //     },
        

       
    //   ],
    // }
  ];

  private Menus$ = new BehaviorSubject<menuInterface[]>([]);
  public responseMenus$: Observable<menuInterface[]> = this.Menus$.asObservable();

  constructor() { }

  consumirMenus() {
    this.Menus$.next(this.menus)
    // let menus: any[] = [];
    // menus = JSON.parse(localStorage.getItem('menus'));
    // this.Menus$.next(menus);
  }

  setearMenusFiltrado(item) {
    this.Menus$.next(item);
    localStorage.setItem("menus", JSON.stringify(item));
  }
}
